export const FIRESTORE_PREFIX = process.env.NODE_ENV === 'development' ? 'dev_' : ''

export const RECORD_COLLECTION = 'bp_records'

export const CREATE_RECORD_FILES_CACHE_KEY = 'bpShare'
